import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { LoginGuard } from '../auth/loginGuard';
import { ChatComponent } from '../physician/chat/chat.component';
import { DashboardComponent } from '../physician/dashboard/dashboard.component';
import { PhysicianFavoritesComponent } from '../physician/favorites/physician-favorites/physician-favorites.component';
import { PhysicianLayoutComponent } from '../physician/layout/physician-layout.component';
import { PracticeProfileComponent } from '../physician/profile/practice/practice-profile.component';
import { PracticeProfilesComponent } from '../physician/profile/practice/practice-profiles/practice-profiles.component';
import { PaymentsListComponent } from '../physician/setup/payments-list/payments-list.component';
import { SetupCheckoutComponent } from '../physician/setup/setup-checkout/setup-checkout.component';
import { SetupCompleteComponent } from '../physician/setup/setup-checkout/setup-complete.component';
import { SetupOrganizationComponent } from '../physician/setup/setup-organization/setup-organization.component';
import { SetupPaymentMethodComponent } from '../physician/setup/setup-payment-method/setup-payment-method.component';
import { SetupPracticeComponent } from '../physician/setup/setup-practice/setup-practice.component';
import { SetupSummaryComponent } from '../physician/setup/setup-summary/setup-summary/setup-summary.component';
import { CaselistComponent } from './caselist/caselist.component';
import { CasemanagerDashboardComponent } from './casemanager-dashboard/casemanager-dashboard.component';
import { CasemanagerLayoutWithoutSelectorComponentComponent } from './layout/casemanager-layout/casemanager-layout-without-selector-component.component';
import { CasemanagerLayoutComponent } from './layout/casemanager-layout/casemanager-layout.component';


const routes: Routes = [
  {
    path: 'casemanager',
    component: CasemanagerLayoutComponent,
    children: [
      { path: '', redirectTo: 'cmdashboard', pathMatch: 'full' },
      { path: 'cmdashboard', component: CasemanagerDashboardComponent, canActivate: [LoginGuard] },
      { path: 'caselist', component: CaselistComponent, canActivate: [LoginGuard] },
      {
        path: "favorites",
        component: PhysicianFavoritesComponent,
        canActivate: [LoginGuard],
      },
      { path: "messages", component: ChatComponent, canActivate: [LoginGuard] },
      {
        path: "patients",
        loadChildren: "../patients/patients.module#PatientsModule",
      },
      {
        path: "practitioners",
        loadChildren:
          "../practitioners/practitioners.module#PractitionersModule",
      },
      {
        path: "referrals",
        loadChildren: "../referrals/referrals.module#ReferralsModule",
      },
      { path: "events", loadChildren: "../events/events.module#EventsModule" },
     
      {
        path: "physicianPatient",
        loadChildren: "../physician/patient/patient-search.module#PatientSearchModule",
      },
      {
        path: "searchReferral",
        loadChildren: "../physician/referral/referral-search.module#ReferralSearchModule",
      },
     
      // { path: 'professionals', component: ManagedProfessionalsComponent, canActivate: [LoginGuard] },
      // { path: 'healthOrganizations', component: HealthOrganizationStatusComponent, canActivate : [LoginGuard]},
      // { path: 'impersonateUser', component: UserImpersonateSelectionComponent, canActivate : [LoginGuard]},
      // { path: 'manageTemplateForms', component: ManageTemplateFormsComponent, canActivate: [LoginGuard]},
      // { path: 'manageTemplateForms/details/:id', component: FormDocumentDetailsComponent, canActivate: [LoginGuard] },
    ]
  },
  {
    path: "casemanager/profile",
    component: CasemanagerLayoutWithoutSelectorComponentComponent,
    children: [
      {
        path: "summary",
        component: SetupSummaryComponent,
        canActivate: [LoginGuard],
      },
      {
        path: "setup",
        component: SetupPracticeComponent,
        canActivate: [LoginGuard],
      },
      {
        path: "setupOrganization",
        component: SetupOrganizationComponent,
        canActivate: [LoginGuard],
      },
      {
        path: "setupCheckout",
        component: SetupCheckoutComponent,
        canActivate: [LoginGuard],
      },
      {
        path: "setupCompleted",
        component: SetupCompleteComponent,
        canActivate: [LoginGuard],
      },
      {
        path: "setupPaymetMethod",
        component: SetupPaymentMethodComponent,
        canActivate: [LoginGuard],
      },
      {
        path: "payments",
        component: PaymentsListComponent,
        canActivate: [LoginGuard],
      },
      {
        path: "",
        loadChildren:
          "../physician/profile/physician/physician-profile.module#PhysicianProfileModule",
        canActivate: [LoginGuard],
      },
    ],
  },
  {
    path: "Practice",
    component: PhysicianLayoutComponent,
    children: [
      { path: "", component: DashboardComponent },
      { path: "profile", component: PracticeProfileComponent },
      { path: "profile/edit", component: PracticeProfileComponent },
      { path: "profiles", component: PracticeProfilesComponent },
      { path: "profile/setup", component: SetupSummaryComponent },
    ],
  },
];
@NgModule({
  // imports: [RouterModule.forChild(routes)],
  // exports: [RouterModule]
  declarations: [],
  imports: [ReactiveFormsModule, RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CaseManagerRoutingModule { }
